<template>
  <div>
    <BasePage v-bind="config" :list="filterList" v-on="listeners"></BasePage>
  </div>
</template>

<script>
import BasePage from './BasePage.vue'
import {sspApi} from '@/api';
import _ from 'lodash';
import {PlatformEnum, StatusEnum, AccessMethodEnum} from '@/enums/enums';

export default {
  components: {
    BasePage
  },
  data: function () {
    return {
      platformList: [],
      statusList: [],
      accessMethodList: [],
      queryCondition: {
        id: '',
        name: '',
        accessType: '',
        platformId: '',
        modifier: '',
        status: ''
      },
      list: [],
      listeners: {
        input: this.onInput,
        operation: this.doOperation,
        action: this.doAction
      },
      config: {
        searchConfigs: [
          [
            {name: 'id', label: '媒体ID(Media ID)', ctx: 'inputText'},
            {name: 'name', label: '媒体名称(Media Name)', ctx: 'inputText'},
            {
              name: 'platformId', label: '操作系统(OS)', ctx: 'inputSelect',
              options: Object.values(PlatformEnum)
            },
            {name: 'modifier', label: '修改人(Modifier)', ctx: 'inputText'},
            {
              name: 'status', label: '状态(Status)', ctx: 'inputSelect',
              options: Object.values(StatusEnum)
            }
          ]
        ],
        tableConfigs: [
          {prop: 'id', label: '媒体ID(Media ID)'},
          {prop: 'name', label: '媒体名称(Media Name)'},
          {prop: 'accessMethod', label: '接入方式(Access Method)', width: '200'},
          {prop: 'platformName', label: '操作系统(OS)', width: '100'},
          {prop: 'updateTime', label: '修改时间(Modification Time)', width: '200'},
          {prop: 'modifier', label: '修改人(Modifier)'},
          {prop: 'statusName', label: '状态(Status)', width: '100'},
          {prop: 'operation', label: '操作(Operate)', width: '105'}
        ],
        showExport: false
      }
    }
  },
  created: function () {
    sspApi.listMedia().then((response) => {
      this.list = response.map(it => {
        const platform = Object.values(PlatformEnum).find(p => p.id === it.platformId);
        const status = Object.values(StatusEnum).find(s => s.id === it.status);
        const accessMethod = Object.values(AccessMethodEnum).find(s => s.id === it.accessType);
        return {
          ...it,
          platformName: platform ? platform.name : '',
          statusName: status ? status.name : '',
          accessMethod: accessMethod ? accessMethod.name : '',
        }
      });
    }).catch(this.$rejectAjaxError());
  },
  computed: {
    filterList: function () {
      let {id, name, accessType, platformId, modifier, status} = this.queryCondition
      return _.filter(this.list, (it) => {
        return (id === '' || String(it.id).includes(id)) &&
            (name === '' || String(it.name).includes(name)) &&
            (accessType === '' || String(it.accessType).includes(accessType)) &&
            (platformId === '' || String(it.platformId).includes(platformId)) &&
            (modifier === '' || String(it.modifier).includes(modifier)) &&
            (status === '' || it.status === status)
      })
    }
  },
  methods: {
    onInput: function (val) {
      _.assign(this.queryCondition, val);
    },
    doOperation: function (op) {
      let mediaId = op.item.id
      this.$router.push({name: 'mediaEdit', params: {mediaId}})
    },
    doAction: function () {
      this.$router.push({name: 'mediaNew'})
    }
  }
}
</script>